import * as Sentry from '@sentry/react';

type Extra = Record<string, unknown>;

/** Forwards application logs to Sentry. Intentionally does not write to the browser console. */
export const logger = {
  error(message: string, error?: unknown, extra?: Extra) {
    if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message, ...extra } });
    } else if (error !== undefined) {
      Sentry.captureException(new Error(message), { extra: { cause: error, ...extra } });
    } else {
      Sentry.captureException(new Error(message), { extra });
    }
  },
  warn(message: string, extra?: Extra) {
    Sentry.captureMessage(message, { level: 'warning', extra });
  },
  info(message: string, extra?: Extra) {
    Sentry.captureMessage(message, { level: 'info', extra });
  },
  // alias so `logger.log(...)` reads like the console call it replaces
  log(message: string, extra?: Extra) {
    Sentry.captureMessage(message, { level: 'info', extra });
  },
};
